var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 45,
    viewBox: "0 0 36 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1526 7.91053C28.9421 7.48421 24.0632 5.2579 20.3684 1.56316L19.4211 0.568421C19.0421 0.189474 18.5211 0 18 0C17.4789 0 16.9579 0.189474 16.5789 0.568421L15.6316 1.56316C11.9368 5.2579 7.05789 7.48421 1.84737 7.91053C0.805263 8.00526 0 8.85789 0 9.9V15.6316C0 27.6632 6.53684 38.8421 17.0053 44.7632C17.2895 44.9526 17.6684 45 18 45C18.3316 45 18.6632 44.9053 18.9947 44.7632C29.4632 38.8421 36 27.6632 36 15.6316V9.9C36 8.85789 35.1947 8.00526 34.1526 7.91053ZM26.6684 18.6632L17.8105 28.2789C17.4316 28.6579 16.9105 28.8947 16.3895 28.9421H16.3421C15.8211 28.9421 15.3 28.7526 14.9211 28.3737L9.94737 23.3053C9.18947 22.5474 9.18947 21.2684 9.94737 20.5105C10.7053 19.7526 11.9842 19.7526 12.7421 20.5105L16.2947 24.0632L23.7316 15.9632C24.4895 15.1579 25.7211 15.1105 26.5263 15.8211C27.3316 16.5789 27.3789 17.8579 26.6684 18.6632Z",
    fill: "#0F5671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.8cf978680020839b7ad6fc175f1b71b2.svg";
export { ForwardRef as ReactComponent };